import RefreshIcon from "@mui/icons-material/CachedRounded";
import { Box, Button, Stack } from "@mui/material";
import { useCallback, useState } from "react";
import RecordCounter from "@entrilia/shared/components/filters/RecordCounter";
import { useGridDataSourceWithRange } from "@entrilia/shared/components/grid/gridHooks";
import SearchField from "@entrilia/shared/components/inputs/SearchField";
import { scrollGridToTop } from "@entrilia/shared/utilities/dataGridApiHelper";
import adminApi from "../../../api/adminApi";
import ReviewedApprovalsGrid from "./ReviewedApprovalsGrid";

const ReviewedApprovalsList = () => {
  const [searchTerm, setSearchTerm] = useState("");

  const { gridApiRef, dataSource, totalRows, isLoading, isRefreshing, refreshDataSource } = useGridDataSourceWithRange(
    adminApi.getApprovalsReviewedByUser,
    { search: searchTerm }
  );

  const handleSearch = useCallback(
    (value: string) => {
      const search = value.trim().toLocaleLowerCase();
      if (search.length === 0 || search.length > 1) {
        scrollGridToTop(gridApiRef);
        setSearchTerm(search);
      }
    },
    [gridApiRef]
  );

  return (
    <Stack spacing={2} sx={{ height: "100%" }}>
      <Box sx={{ width: "100%", display: "flex", justifyContent: "space-between" }}>
        <RecordCounter records={totalRows ?? 0} hide={isLoading} />
        <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
          <SearchField debounceTimeMs={300} onSearch={handleSearch} />
          <Button
            variant="outlined"
            color="secondary"
            disabled={isLoading}
            loading={isRefreshing}
            startIcon={<RefreshIcon />}
            onClick={refreshDataSource}
          >
            Refresh
          </Button>
        </Stack>
      </Box>
      <ReviewedApprovalsGrid dataSource={dataSource} apiRef={gridApiRef} />
    </Stack>
  );
};

export default ReviewedApprovalsList;
